export const DEMO_MAX_MESSAGES = 6;
export const DEMO_BASE_CODE = `// Código de exemplo para testes de automação de commits

// Interface para definir a estrutura de um usuário
interface User {
    id: string;
    name: string;
    email: string;
}

// Função para gerar um uuid (Universally Unique IDentifier)
function uuid(): string {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}

// Função para encontrar um usuário por ID em uma lista de usuários
function findUserById(users: User[], id: string): User | undefined {
    return users.find(user => user.id === id);
}

// Exemplo de uso das funções e interface
const users: User[] = [
    { id: uuid(), name: 'Alice', email: 'alice@example.com' },
    { id: uuid(), name: 'Bob', email: 'bob@example.com' },
];

const userId = users[0].id;

console.log(findUserById(users, userId)); // Retorno: { id: 1, name: 'Alice', email: 'alice@example.com' }
`;

export const DEMO_EXAMPLE_MESSAGES = [
	'🔖 chore(release): Bump version to 0.19.5',
	'✨ feat(components/CheckPicker): Add CheckPicker component using rsuite library',
	'♻️ refactor(auth/register): Refactor phone input handling in registration form',
	'🐛 fix(auth/login): Fix login form not submitting on enter key press',
	'💄 style(pages/index): Refactor button and values section for improved readability and consistency.',
	'⚡ fix(app/page): Redirect to external URL instead of rendering QR code.',
	'🚀 feat(app/page): Add new feature to improve user experience.',
];
